import React from 'react';
import BookingWidget from '../components/BookingWidget';
import HeroSection from '../components/HeroSection';
import StaysInSpotlight from '../components/StaysInSpotlight';
import PawStories from '../components/PawStories';
import MeetTheFounders from '../components/MeetTheFounders';

const Stays = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Booking Widget */}
      <div className="bg-[#FF5E4C] py-[20px] md:pt-0">
        <BookingWidget />
      </div>
      
      {/* Main Content */}
      <div className="bg-[#f8f8f8]">
        {/* In the Spotlight — stays only (same carousel as Events tab) */}
        <HeroSection mode="stays" />
        <StaysInSpotlight />

        {/* Paw Stories Section */}
        <div className=" bg-[#f8f8f8]">
          <PawStories />
        </div>

        {/* Meet the Founders Section */}
        <div className="bg-[#f8f8f8]">
          <MeetTheFounders />
        </div>
      </div>
    </div>
  );
};

export default Stays; 